<div [style.background-color]="background" class="p-1 tool-wrapper">
    <p [style.color]="titleColor" class="title-css px-2 pb-1">{{title}}</p>
    <p [style.color]="color" class="px-2  description-css">{{ text }}</p>
   
</div>